import { useMessages } from './StudentLoanMatchGuidanceBox/hooks';

import MessageBox from '../../Shared/components-v2/message-box/message-box';

export interface StudentLoanMatchGuidanceBoxProps {
  location: 'goal_overview_employer_match' | 'account_claim_contribution_setup_success';
}

const StudentLoanMatchGuidanceBox = ({ location }: StudentLoanMatchGuidanceBoxProps) => {
  const { loading, messages } = useMessages({ location });

  if (loading) return null;

  return <MessageBox messages={messages} location={location} />;
};

export default StudentLoanMatchGuidanceBox;
